module.exports = __webpack_public_path__ + "img/icon_userEdit.08902306.svg";